import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/components/layouts/main-layout/main-layout.component';
import { PublicLayoutComponent } from './shared/components/layouts/public-layout/public-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { IsSignedGuard } from './core/guards/is-signed.guard';
import { ClearStateOnRootChangeGuard } from './core/guards/clear-state.guard';
import { Sgc1MiddlewareComponent } from './shared/components/sgc1-middleware/sgc1-middleware.component';
import { environment } from 'src/environments/environment';
import { RedirectGuard } from './core/guards/redirect.guard';
import { MainLayoutMonitorComponent } from './shared/components/layouts/main-layout-monitor/main-layout-monitor.component';
import { PublicLayoutMonitorComponent } from './shared/components/layouts/public-layout-monitor/public-layout-monitor.component';

export const routes: Routes = [
  {
    path: 'login',
    component: PublicLayoutComponent,
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
    canActivate: [IsSignedGuard, ClearStateOnRootChangeGuard]
  },
  {
    path: 'home',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'maintenance/contracts',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/contract/contract.module').then(m => m.ContractModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/contracts/contract',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/service-concept/service-concept.module').then(m => m.ServiceConceptModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'maintenance/contracts/service-concept-types',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/service-concept/service-concept.module').then(m => m.ServiceConceptModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/attendance',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/attendance/attendance.module').then(m => m.AttendanceModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/centers',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/center/center.module').then(m => m.CenterModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/families',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/family/family.module').then(m => m.FamilyModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/families/family',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/family/family.module').then(m => m.FamilyModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'maintenance/holidays',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/holidays/holidays.module').then(m => m.HolidaysModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/exercises',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/exercise/exercise.module').then(m => m.ExerciseModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  /* {
    path: 'monitors',    
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/monitor/monitor.module').then(m => m.MonitorModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  }, */
  {
    path: 'configuration/reporting',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/reporting/reporting.module').then(m => m.ReportingModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'portalGM/monthly-service-entry',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/attendance-services/attendance-services.module').then(m => m.AttendanceServicesModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/schools',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/school/school.module').then(m => m.SchoolModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/schools/school',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/school/school.module').then(m => m.SchoolModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'maintenance/invoice-templates',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/invoice-template/invoice-template.module').then(m => m.InvoiceTemplateModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'portalGM/tasks',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/task/task.module').then(m => m.TaskModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'configuration/menus',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/permissions/permission.module').then(m => m.PermissionModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'maintenance/imports',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/imports/imports.module').then(m => m.ImportsModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'reports',
    component: MainLayoutComponent,
    loadChildren: () => import('./modules/reporting/reporting.module').then(m => m.ReportingModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  }, 
  {
    path: 'monitor/login',
    component: PublicLayoutMonitorComponent,
    loadChildren: () => import('./modules/monitor/modules/login/login.module').then(m => m.LoginModule),
    canActivate: [IsSignedGuard, ClearStateOnRootChangeGuard]
  },
  {
    path: 'monitor/home',
    component: MainLayoutMonitorComponent,
    loadChildren: () => import('./modules/monitor/modules/home/home.module').then(m => m.HomeModule),
    canLoad: [AuthGuard],
    canActivate: [ClearStateOnRootChangeGuard]
  },
  {
    path: 'monitor/home/daily-attendance',
    component: MainLayoutMonitorComponent,
    loadChildren: () => import('./modules/monitor/modules/daily-attendance/daily-attendance.module').then(m => m.DailyAttendanceModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'monitor/home/service-attendance-adjustment',
    component: MainLayoutMonitorComponent,
    loadChildren: () => import('./modules/monitor/modules/service-attendance-adjustment/service-attendance-adjustment.module').then(m => m.ServiceAttendanceAdjustmentModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'monitor/home/prediction-attendance',
    component: MainLayoutMonitorComponent,
    loadChildren: () => import('./modules/monitor/modules/prediction-attendance/prediction-attendance.module').then(m => m.PredictionAttendanceModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'access-denied',
    component: MainLayoutComponent ,
    loadChildren: () => import('./modules/access-denied/access-denied.module').then(m => m.AccessDeniedModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'sgc1-login',
    component: Sgc1MiddlewareComponent,
  },
  {
    path: '',
    canActivate: [RedirectGuard],
     component: RedirectGuard,
     data: {
       externalUrl: environment.sgc1Url + 'Servicios/Default.aspx'
     }
  },
  {
    path: '**',
    component: MainLayoutComponent ,
    loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule),
    canActivate: [IsSignedGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
